import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DateRangePicker.css';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { it } from 'date-fns/locale/it';

// Registra la locale italiana
registerLocale('it', it);

const SingleDatePicker = ({ 
  selectedDate, 
  onChange, 
  className = '',
  placeholder = 'Seleziona data',
  minDate = null,
  maxDate = null,
  disabled = false,
  autoFocus = false
}) => {
  const handleDateChange = (date) => {
    if (date) {
      // Usa il timezone locale per evitare problemi di conversione
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formatted = `${year}-${month}-${day}`;
      onChange(formatted);
    } else {
      onChange('');
    }
  };

  // Converti stringa ISO in oggetto Date usando timezone locale
  const dateObj = selectedDate ? new Date(selectedDate + 'T12:00:00') : null;

  return (
    <div className={`relative ${className}`}>
      <CalendarIcon className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none z-10" />
      <DatePicker
        selected={dateObj}
        onChange={handleDateChange}
        minDate={minDate}
        maxDate={maxDate}
        dateFormat="dd/MM/yyyy"
        locale="it"
        placeholderText={placeholder}
        className={`w-full pl-8 pr-3 py-1.5 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors ${disabled ? 'bg-gray-100 cursor-not-allowed' : ''}`}
        wrapperClassName="w-full"
        calendarClassName="shadow-xl border-gray-200"
        popperClassName="datepicker-popper-table"
        showMonthDropdown
        showYearDropdown
        dropdownMode="select"
        isClearable
        disabled={disabled}
        autoFocus={autoFocus}
        popperPlacement="bottom-start"
        popperProps={{
          strategy: 'fixed'
        }}
      />
    </div>
  );
};

export default SingleDatePicker;

